import "./project-tag.css"

const ProjectTag = ({ tag }) => (
  <div className="project-tag">
    <span>{tag}</span>
  </div>
)

export default ProjectTag;